import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { garageInfo } from '../data/mock';

const Footer = () => {
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    // Navigate to home first if not already there
    if (window.location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          const offset = 80;
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - offset;
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 100);
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        const offset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }
  };

  return (
    <footer className="bg-slate-900 text-white">
      <div className="container mx-auto px-4">
        {/* Main Footer */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 py-12">
          {/* About */}
          <div>
            <h3 className="text-xl font-bold mb-4 bg-gradient-to-r from-sky-400 to-slate-300 bg-clip-text text-transparent">
              {garageInfo.name}
            </h3>
            <p className="text-slate-400 mb-4 leading-relaxed">
              Votre partenaire de confiance pour l'entretien et la réparation automobile à Chêne-Bourg depuis 2015.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Liens Rapides</h4>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('accueil')}
                  className="text-slate-400 hover:text-sky-400 transition-colors"
                >
                  Accueil
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-slate-400 hover:text-sky-400 transition-colors"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('apropos')}
                  className="text-slate-400 hover:text-sky-400 transition-colors"
                >
                  À Propos
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('temoignages')}
                  className="text-slate-400 hover:text-sky-400 transition-colors"
                >
                  Témoignages
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-slate-400 hover:text-sky-400 transition-colors"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-4">Nos Services</h4>
            <ul className="space-y-2 text-slate-400">
              <li>Toute Mécanique</li>
              <li>Diagnostic & Réparation</li>
              <li>Changement de Pneus</li>
              <li>Entretien Constructeur</li>
              <li>Géométrie</li>
              <li>Climatisation</li>
              <li>Préparation Expertise</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin className="text-sky-400 flex-shrink-0 mt-1" size={18} />
                <span className="text-slate-400">
                  {garageInfo.address}<br />
                  {garageInfo.city}
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="text-sky-400 flex-shrink-0" size={18} />
                <a href={`tel:${garageInfo.phoneLink}`} className="text-slate-400 hover:text-sky-400 transition-colors">
                  {garageInfo.phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="text-sky-400 flex-shrink-0" size={18} />
                <a href={`mailto:${garageInfo.email}`} className="text-slate-400 hover:text-sky-400 transition-colors break-all">
                  {garageInfo.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-slate-800 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-400 text-sm">
              © {new Date().getFullYear()} {garageInfo.name}. Tous droits réservés.
            </p>
            <div className="flex gap-6 text-sm">
              <button 
                onClick={() => navigate('/mentions-legales')}
                className="text-slate-400 hover:text-sky-400 transition-colors"
              >
                Mentions légales
              </button>
              <button 
                onClick={() => navigate('/politique-confidentialite')}
                className="text-slate-400 hover:text-sky-400 transition-colors"
              >
                Politique de confidentialité
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
